export default __webpack_public_path__ + "static/media/talisis.d3fc2b94.png";